export default __webpack_public_path__ + "static/media/da_ngon_ngu_kr.002d25d1.png";